import React from 'react';
import { Form, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const ProductImageUpload = ({ fileList, onFileChange }) => {
  return (
    <Form.Item 
      label="Book image" 
      valuePropName="image"
      help="Add or change the book cover image. Remove and upload to replace."
      style={{ marginBottom: "15px" }}
    >
      <Upload
        listType="picture-card"
        beforeUpload={() => false}
        name="image"
        fileList={fileList}
        maxCount={1}
        onChange={onFileChange}
        accept="image/*"
        style={{ width: '100%' }}
      >
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </div>
      </Upload>
    </Form.Item>
  );
};

export default ProductImageUpload;
